module.exports = __webpack_public_path__ + "img/dispatchbanner.3b9afe43.jpg";